module.exports = __webpack_public_path__ + "static/media/shop-5.ee5385b0.jpg";